import moment from 'moment'

import { getResolvedHosts } from 'components/attacks/utils/attacks'
import { formatK8AttackIntoIlfiAttack } from 'components/attacks/utils/kubernetes'
import duration from 'duration'
import { formatDateTime } from 'utils/time/date'

// Search term requirements
// 1. a.typeSearchTerm (snakecase) e.g 'shutdown', 'io'
// 2. stage (lowercase) e.g. 'failed' 'success'
// 3. started at (lowercase) e.g. 'a year ago 5/22/2017 8:14pm'
// 4. ended at (lowercase) e.g. 'a year ago 5/22/2017 8:16pm'
// 5. duration e.g. '1 minute'
// 6. container e.g. 'containers'
export function createString(attack) {
  const formatTime = (time) => formatDateTime(moment(new Date(time)))
  const labels = attack.target_type === 'Container' ? 'containers' : ''
  const flagIndex = attack.args.indexOf('-l')
  const durationTerm =
    flagIndex !== -1 ? duration(attack.args[flagIndex + 1]) : ''

  return [
    attack.args[0],
    attack.stage.toLowerCase(),
    formatTime(attack.start_time),
    formatTime(attack.end_time),
    durationTerm,
    labels
  ].join(' ')
}

export default function (guids, attacks) {
  return guids.reduce((accum, guid) => {
    const attack = attacks[guid]

    if (attack) {
      accum[guid] = createString(attack)
    }
    return accum
  }, {})
}

export function createIlfiAttackSearchMap(attack) {
  const out = [
    attack.args[0],
    attack.infra_command.commandType,
    attack.stage,
    attack.create_user,
    ...getResolvedHosts(attack),
    attack.target_type === 'Container' ? 'containers' : ''
  ].filter(Boolean)

  return out
}

export function createK8AttackSearchMap(k8Attack) {
  return createIlfiAttackSearchMap(formatK8AttackIntoIlfiAttack(k8Attack))
}

export function createWebhookSearchMap(webhook) {
  const out = [
    webhook.state,
    webhook.name,
    webhook.createdBy,
    webhook.format,
    webhook.webhookEndpoint?.method,
    webhook.description,
    webhook.isPrivateNetwork ? 'Private' : 'Public'
  ].filter(Boolean)

  return out
}

export function defaultStringSearchMap(text) {
  return [text]
}

export function createClusterSearchMap(cluster) {
  const out = [
    cluster.assetId,
    cluster.clusterName,
    cluster.owningTeamId,
    ...(cluster.availableNamespaces || []),
    ...(cluster.currentlySharedNamespaces || []),
    cluster.region
  ].filter(Boolean)
  return out
}
